const EventBus = window.VueEventBus
import CartMixins from '../../../components/_mixins/location-checkout'

export default {
  name: 're-cart-timer-alert',
  mixins: [CartMixins],
  props: {
    timerAlert: {default: 'Your cart is waiting. Time to complete your purchase: '},
    showTimerCountdown: {default: true},
    containerClass: {default: 're-global-cart-timer-container'},
    classes: {default: 're-global-cart-timer'},
    cartButtonClass: {default: ''},
  },
  computed: {
    showIt() {
      return this.showGlobalTimerMessage
    }
  }
}
